import React, { useContext, useEffect } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { designActions } from '../../actions';
import { DesignContext } from '../../containers/GraphicBuilder/GraphicBuilder';
import { Dropdown } from 'semantic-ui-react';
import './VLineToolbar.css';

const VLineToolbar = () => {
  const dispatch = useDispatch();
  const { activePageRef } = useContext(DesignContext);
  const selectedEntity = useSelector(state => state.design.selectedEntity);
  const entityData = useSelector(state => {
    const selectedEntityId = _.get(state, 'design.selectedEntity.id');
    return _.get(state, ['design', 'entitiesState', selectedEntityId, 'data'], null);
  });

  const colorPickerColor = useSelector(state => state.design.colorPickerColor);
  const sidePanel = useSelector(state => state.design.sidePanel);

  useEffect(() => {
    const bgColor = _.get(entityData, 'color', '#000');
    dispatch(designActions.changeColorPickerColor(bgColor));
  }, [dispatch, entityData]);

  useEffect(() => {
    if (!entityData) return;
    const bgColor = _.get(entityData, 'color', '#000');

    if (sidePanel === 'colorPicker' && colorPickerColor !== bgColor) {
      const changes = { ...entityData, color: colorPickerColor };
      dispatch(designActions.changeEntityData(activePageRef.current, selectedEntity.id, changes));
    }
  }, [activePageRef, colorPickerColor, dispatch, entityData, selectedEntity.id, sidePanel]);

  const onMouseDown = () => {
    if (!entityData) return;
    const bgColor = _.get(entityData, 'color', '#000');
    dispatch(designActions.changeColorPickerColor(bgColor));
    dispatch(designActions.setSidePanel('colorPicker'));
  };

  const thickness = [];
  for (let i = 0; i < 16; i++) {
    thickness.push({ key: i, text: i, value: i });
  }

  const onChangeThickness = (e, { value }) => {
    if (!entityData || _.isNil(selectedEntity.id)) return;
    const changes = { ...entityData, thickness: value };
    dispatch(designActions.changeEntityData(activePageRef.current, selectedEntity.id, changes));
  };

  const currentThickness = Number(_.get(entityData, 'thickness'));

  return (
    <>
      <div className="colorPalette">
        <span
          className={`color`}
          style={{ backgroundColor: `${_.get(entityData, 'color', '#000')}` }}
          onMouseDown={onMouseDown}
        ></span>
      </div>
      <div className="vLine thickness button">
        <Dropdown
          placeholder="--"
          fluid
          selection
          options={thickness}
          value={Number.isFinite(currentThickness) ? currentThickness : undefined}
          onChange={onChangeThickness}
        />
      </div>
    </>
  );
};

export default VLineToolbar;
